import { Row, Col } from "antd";
import { withTranslation, TFunction } from "react-i18next";
import Container from "../../common/Container";

import { FooterSection, Title, Para, Large, Chat, Language } from "./styles";

const Footer = ({ t }: { t: TFunction }) => {
  return (
    <>
      <FooterSection>
        <Container>
          <Row justify="space-between">
            <Col lg={10} md={10} sm={12} xs={12}>
              <Language>
                <span style={{ color: "#4d2b1f" }}>{t("Contact")}</span>
              </Language>
              <Large to="/">{t("Posez toutes vos questions")}</Large>
              <Para>
                <span style={{ color: "black" }}>{t(`00225 2722392267`)}</span>
              </Para>
              <span style={{ color: "black" }}>
                <a href="mailto:tndjina@simtci.com">
                  <Chat>
                    <span style={{ color: "#ff825c" }}>{t(`Discutons`)}</span>
                  </Chat>
                </a>
              </span>
            </Col>
            <Col lg={8} md={8} sm={12} xs={12}>
              <Title>
                <span style={{ color: "#4d2b1f" }}>{t("Nous écrire")}</span>
              </Title>
              <Large to="/">
                <a href="mailto:tndjina@simtci.com">tndjina@simtci.com</a>
              </Large>
              <Large to="/">
                <a href="mailto:ndosso@simtci.com">ndosso@simtci.com</a>
              </Large>
              <Large to="/">
                <a href="mailto:contact@simtci.com">contact@simtci.com</a>
              </Large>
            </Col>
            <Col lg={6} md={6} sm={12} xs={12}>
              <Language>
                <span style={{ color: "#4d2b1f" }}>{t("Adresse")}</span>
              </Language>
              <Para style={{ color: "black" }}>
                <Para style={{ color: "black" }}>Abidjan</Para>
                Cité Cafeier 7, derrière la Pharmacie des Allées
              </Para>
              <Para style={{ color: "black" }}>Maison numéro 350</Para>
            </Col>
          </Row>
        </Container>
      </FooterSection>
    </>
  );
};

export default withTranslation()(Footer);
